import Cookies from 'js-cookie';
import loadScript from 'load-script';

const convertOpt = (option) => {
	let op = {};
	if (typeof option === 'string') {
		op = { name: option };
	}
	if (typeof option === 'object') {
		const newOption = {};
		const newOptionList = Object.keys(option);
		if (newOptionList.length > 0) {
			newOptionList.forEach((key) => {
				if (option[key] !== '' && option[key] !== undefined) newOption[key] = option[key];
			});
		}

		op = { ...newOption };
	}
	return op;
};

export function loadSdkScriptAsync() {
	return new Promise((resolve, reject) => {
		const isMobile = /Mobi|Android/i.test(navigator.userAgent);
		const url = isMobile ? 'https://ssl.nexon.com/s1/da/a2s.mobile.js' : 'https://ssl.nexon.com/s1/da/a2s.js';

		loadScript(url, (err) => {
			if (err) {
				console.error('SDK 로드 실패', err);
				reject(err);
			} else {
				resolve(window.$h); // SDK가 성공적으로 로드됨
			}
		});
	});
}

const a2s = {
	region: '',
	countryCode: '',
	gameCode: '',
	gameCodeType: '',
	sdkLoaded: false,
	isDirect: false,
	async init() {
		if (!this.sdkLoaded) {
			const res = await loadSdkScriptAsync(); // 위에서 만든 Promise 버전
			this.sdkLoaded = !!res.a2s;
		}
	},
	async process(object, option = {}, fnName) {
		this.init();
		let timeout;
		if (!window.$h || !window.$h.a2s) {
			timeout = setTimeout(() => a2s.view(object, option), 500);
			return;
		}

		const gameCode = Cookies.get('gameCode');
		if (gameCode) {
			this.gameCode = gameCode;
		}

		const gameCodeType = Cookies.get('gameCodeType');
		if (gameCodeType) {
			this.gameCodeType = gameCodeType;
		}

		const prefix = this.getPrefix();
		const op = {
			...option,
			logId: `${prefix}_${object}`,
			countryCode: this.region === 'global' ? this.countryCode : '',
			gameCode: this.gameCode,
			gameCodeType: this.gameCodeType,
		};

		clearTimeout(timeout);
		if (window.$h.a2s[fnName]) {
			window.$h.a2s[fnName](`${prefix}_${object}`, JSON.stringify(convertOpt(op)));
		}
	},
	async view(object, option = {}) {
		this.process(object, option, 'sendContentsLog');
	},
	async click(object, option = {}) {
		this.process(object, option, 'sendClickLog');
	},
	setRegion(region) {
		this.region = region;
	},
	setCountryCode(countryCode) {
		this.countryCode = countryCode;
	},
	setIsDirect(isDirect) {
		this.isDirect = isDirect;
	},
	getPrefix() {
		const region = this.region === 'global' ? 'west' : this.region;
		const direct = this.isDirect ? 'direct' : 'buynx';
		return `${region}_${direct}`;
	},
};

export default {
	install(app) {
		app.prototype.$a2s = a2s;
	},
};
